import { clearPersistedState } from '@/redux/localStorage';

export const USER_CONTEXT_KEY = 'userContext';

/**
 * Полная очистка сессии на этом устройстве.
 *
 * Раньше в точках выхода удалялся только userContext, а снимок Redux в ключе
 * state оставался - и следующий пользователь на том же компьютере стартовал с
 * чужим активным отделением, кассой и очередями заявок. Для кассового
 * приложения это прямо неверные цифры на экране, поэтому чистим оба ключа
 * всегда вместе.
 */
export const clearSession = () => {
    try {
        localStorage.removeItem(USER_CONTEXT_KEY);
    } catch (error) {
        console.warn('Не удалось очистить userContext', error);
    }

    clearPersistedState();
};
